import { Accordion, AccordionProps, Flex, FlexProps } from '@chakra-ui/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
  itemsContainerProps?: FlexProps;
  accordionProps?: AccordionProps;
}

const AgendaWrapper: React.FC<Props> = ({
  children,
  itemsContainerProps,
  accordionProps,
}) => (
  <Accordion allowToggle {...accordionProps}>
    <Flex
      flexDir="column"
      rowGap="24px"
      px={{ xs: '4px', md: '16px' }}
      mt="28px"
      {...itemsContainerProps}
    >
      {children}
    </Flex>
  </Accordion>
);

export default AgendaWrapper;
